<template>
  <footer
    v-if="!store.site.loading && acf_options"
    class="site-footer">
    <div class="footer-top">
      <video
        v-if="acf_options.footer_video"
        class="footer-video"
        controlsList="nodownload nofullscreen noremoteplayback"
        oncontextmenu="return false;"
        autoplay
        loop
        muted
        playsinline
        data-speed="0.2">
        <source
          :src="acf_options.footer_video.url"
          type="video/mp4" />
      </video>
      <div class="logo">
        <router-link
          :to="'/'"
          title="Home">
          <img
            v-if="acf_options.site_logo_footer"
            class="h-auto w-60"
            :src="acf_options.site_logo_footer.url"
            :alt="acf_options.site_logo_footer.alt" />
        </router-link>
      </div>
      <div class="footer-menu">
        <footer-menu name="footer-menu" />
        <address
          class="header-6"
          v-html="acf_options.footer_addr"></address>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="copyright">
        <p class="caption">
          &copy; {{ currentYear }} <span v-html="acf_options.footer_copy" />
        </p>
      </div>
      <nav class="legal-menu">
        {{}}
        <ul>
          <li
            v-for="menuItem of menu"
            :key="menuItem.id">
            <router-link
              class="caption"
              :to="convertToRelative(menuItem.url)"
              :target="menuItem.target">
              {{ menuItem.content }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script setup>
import FooterMenu from '@/components/template-parts/FooterMenu.vue'
import { useStore } from '@/stores/main'
import { ref, computed, onBeforeMount } from 'vue'
import useUtils from '@/components/composables/useUtils.js'

const { convertToRelative } = useUtils()

const store = useStore()
const menu = ref(store.menu({ name: 'footer-tagline' }))
const acf_options = ref(null)
const currentYear = computed(() => {
  return new Date().getFullYear()
})

onBeforeMount(async () => {
  acf_options.value = await store.getAcfOptions()
})
</script>

<style lang="scss" scoped>
.site-footer {
  @apply w-full px-[6px] z-3;
  .footer-top {
    @apply overflow-hidden relative bg-humble px-[20px] py-[60px] 
    rounded-tl-[20px] rounded-tr-[20px] rounded-br-[80px] rounded-bl-[80px]
    bg-[url('@/assets/img/footer-logomark.svg')] bg-[40%_38%] bg-[length:250%_250%]
    flex flex-col items-center
    md:items-start md:px-[60px] md:py-[80px] md:bg-cover md:bg-center md:rounded-br-[100px] md:rounded-bl-[100px];

    //random safari bugfix: overflow wont hide in rounded corners.
    transform: translate3d(0, 0, 0);
    .footer-video {
      @apply absolute left-0 top-0 h-full w-full object-cover pointer-events-none;
    }
    .logo {
      @apply z-1;
    }
    .footer-menu {
      @apply flex flex-col mt-20 mx-auto mb-0 gap-20
      md:flex-row md:justify-between md:items-end md:gap-0
      md:mt-[120px] md:w-[90%];

      address {
        @apply relative pt-5 text-center not-italic text-white
        md:pt-7 md:text-left;

        &:deep(p) {
          @apply text-white;
        }

        &:before,
        &:after {
          content: '';
          @apply absolute top-0 left-0 block h-[5px];
        }

        &:before {
          @apply w-full bg-progressive;
        }

        &:after {
          @apply w-1/2 bg-approachable;
        }
      }
      .footer-nav-item-container {
        @apply md:mb-[15px];
      }
    }
  }

  .footer-copyright {
    @apply flex flex-col items-center py-4 gap-4
    md:flex-row md:justify-between md:py-11 md:px-11;
    .copyright {
      @apply md:pt-[2px];
    }

    .legal-menu > ul {
      @apply flex gap-6;
      li {
        a:hover,
        a:focus {
          @apply underline;
        }
      }
    }
  }
}
</style>
